import { Component, ViewEncapsulation, Input, ViewChild } from "@angular/core";
import { environment } from "../../../environments/environment";
import { NgForm } from "@angular/forms";
import { v4 as uuid } from "uuid";

@Component({
  selector: "app-questionnaire-questions",
  templateUrl: "./questionnaire-questions.component.html",
  styleUrls: ["./questionnaire-questions.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class QuestionnaireQuestionsComponent {
  env: any = environment;
  loading = true;
  guid = uuid();

  @Input() questions: any;
  @Input() readonly: boolean = false;

  @ViewChild("Form") public Form: NgForm;
}



// WEBPACK FOOTER //
// /agir/src/app/components/questionnaire-questions/questionnaire-questions.component.ts